
export const tableConfig = {
  minItemsPerPage: 10,
  maxItemsPerPage: 20,
  ddlItemsPerPage: [20,50,100,150,200],
};
